// import './js/firebase';
import './sass/main.scss';
import 'animate.css/animate.css';

import './js/components/creatTheme';

import './js/change-data';
import './js/home-page';
import './js/dataBaseApi';
import './js/movie-search';

import './js/components/back-to-top';

import './js/team';
import './js/modal-window';
import './js/notification';

import './js/render/renderLibrary';

import './js/render/renderHeader';

import './js/localStorage';
import './js/localStoragePage';
